import React, { useState, Fragment } from 'react';
import Typography from '@material-ui/core/Typography';
import AccountPage from '../components/AccountPage';
import FeedbackForm from '../../../components/forms/FeedbackForm';
import Button from '../../../components/Button';


const FeedbackPage = () => {
  const [showForm, setShowForm] = useState(true);

  const onSuccess = () => {
    setShowForm(false);
  };

  return (
    <AccountPage>
      {showForm ? (
        <Fragment>
          <Typography variant="body2" gutterBottom>We&apos;re always looking for ways to make Clickability better for you. Your feedback and ideas are an essential part of how we decide what features to add to the platform!</Typography>
          <FeedbackForm label="What would you most like to see on Clickability?" onSuccess={onSuccess} />
        </Fragment>
      ) : (
        <Fragment>
          <Typography variant="body2" gutterBottom>Thanks! If there&apos;s anything else you would like us to know, come back here any time.</Typography>
          <Button
            variant="outlined"
            disableRipple
            color="primary"
            onClick={()=>setShowForm(true)}
            label="Provide more feedback"
            pointer="right"
            style={{margin: '1rem 1rem 1rem 0'}}
          />
        </Fragment>
      )}
    </AccountPage>
  );

};

export default FeedbackPage;
